import React, { FC } from 'react';
import { TypeaheadRenderType, TypeaheadSelection, UitkTypeahead } from 'uitk-react-typeahead';
import { Icon } from 'graphql/__generated__/types';
import { ElasticSearchAdapter } from '../../search/elastic-search-adapter';
import { LunrSearchAdapter } from '../../search/lunr-search-adapter';

interface SearchBoxDesktop {
  searchHandler: (selection: TypeaheadSelection) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchAdapter: ElasticSearchAdapter | LunrSearchAdapter;
  icon: Icon;
  typeaheadPlaceholder: string;
  label: string;
  typeaheadEmptyResultPlaceholder: string;
  onClick: () => void;
  onDismiss: () => void;
}

const SearchBoxDesktop: FC<SearchBoxDesktop> = (props) => {
  const {
    searchAdapter,
    searchHandler,
    icon,
    typeaheadPlaceholder,
    label,
    typeaheadEmptyResultPlaceholder,
    onInputChange,
    onClick,
    onDismiss,
  } = props;

  return (
    <UitkTypeahead
      id={icon.id}
      name={icon.title}
      icon={icon.token}
      label={label}
      onClick={onClick}
      onDismiss={onDismiss}
      onUpdate={searchHandler}
      onInputChange={onInputChange}
      renderType={TypeaheadRenderType.ADAPTIVE}
      typeaheadEmptyResultPlaceholder={typeaheadEmptyResultPlaceholder}
      typeaheadPlaceholder={typeaheadPlaceholder}
      adapter={searchAdapter || ({} as ElasticSearchAdapter) || ({} as LunrSearchAdapter)}
      allowExactMatch
      hasClearButton
    />
  );
};

export default SearchBoxDesktop;
